import { useCoordinatorTeam, type CoordinatorTeamAgent } from "@/hooks/useCoordinatorTeam";
import { usePermissions } from "@/hooks/usePermissions";
import { useRestrictedConversationVisibility } from "@/hooks/useRestrictedConversationVisibility";
import { ownInboxIsMine, seesWholeInbox } from "@/lib/coordinator-inbox";

export interface CoordinatorInbox {
  teamAgents: CoordinatorTeamAgent[];
  hasTeam: boolean;
  wholeInbox: boolean;
  ownInboxIsMine: boolean;
  resolved: boolean;
}

export function useCoordinatorInbox(): CoordinatorInbox {
  const { agents, loading: teamLoading } = useCoordinatorTeam();
  const { can, isLoading: permissionsLoading } = usePermissions();
  const { agentInboxRestricted, loading: visibilityLoading } = useRestrictedConversationVisibility();
  const hasTeam = agents.length > 0;
  const wholeInbox = seesWholeInbox(can("conversations.view_all"), agentInboxRestricted);
  return {
    teamAgents: agents,
    hasTeam,
    wholeInbox,
    ownInboxIsMine: ownInboxIsMine(hasTeam, wholeInbox),
    resolved: !teamLoading && (!hasTeam || (!permissionsLoading && !visibilityLoading)),
  };
}
